import { FC } from "react";

interface ImagePlaceholderSVGProps {
    classname?: string;
    fill?: string;
}

const ImagePlaceholderSVG: FC<ImagePlaceholderSVGProps> = (props) => {
    return (
        <svg
            className={props.classname}
            xmlns="http://www.w3.org/2000/svg"
            fill={props.fill}
            viewBox="-4.5 0 32 32"
            version="1.1"
        >
            <title>picture</title>
            <path d="M22.080 7.84h-21.2c-0.48 0-0.84 0.36-0.84 0.84v14.6c0 0.48 0.36 0.84 0.84 0.84h21.24c0.48 0 0.84-0.36 0.84-0.84v-14.6c-0.040-0.44-0.36-0.84-0.88-0.84zM21.24 9.52v6.72l-6.2 1.84-6.6-6.56c-0.28-0.28-0.76-0.32-1.080-0.080l-5.68 4.24v-6.16h19.56zM1.68 22.48v-4.72l6.080-4.56 6.44 6.44c0.16 0.16 0.36 0.24 0.6 0.24 0.080 0 0.16 0 0.24-0.040l6.2-1.84v4.48h-19.56zM16.64 15.64c1.28 0 2.36-1.040 2.36-2.36s-1.040-2.36-2.36-2.36-2.36 1.040-2.36 2.36 1.12 2.36 2.36 2.36zM16.64 12.6c0.36 0 0.68 0.32 0.68 0.68s-0.32 0.68-0.68 0.68-0.68-0.32-0.68-0.68 0.36-0.68 0.68-0.68z" />
        </svg>
    );
};

export default ImagePlaceholderSVG;
